import { IModalRoute } from "./ModalRoutes";

export function matchModalRoutes(routes: IModalRoute[], pathParts: string[]): IModalRoute[] {
  const matched: IModalRoute[] = [];

  let currentRoutes = routes;

  for (const part of pathParts) {
    const route = currentRoutes.find((r) => r.name === part);
    if (!route) break;

    matched.push(route);
    currentRoutes = route.children || [];
  }

  return matched;
}

export function useModalPath(): string[] {
  const search = new URLSearchParams(window.location.search);
  const modal = search.get("modal");
  return modal ? modal.split("/") : [];
}

export function matchModalRoute(routes: IModalRoute[], path: string): IModalRoute[] {
  const parts = path.split("/").filter(Boolean);
  const matched: IModalRoute[] = [];

  let current = routes;

  for (const segment of parts) {
    const match = current.find((r) => r.name === segment);
    if (!match) break;
    matched.push(match);
    current = match.children || [];
  }

  return matched;
}
